import {observer} from "mobx-react";
import {Linq, ScrollTable} from "../../ui";
import {ShipmentPackageItemDto} from "../../../api/fms";
import {convertDocumentType} from "../../../api";
import {DialogStore, fmsDocumentPrinterStore, fmsPackageDetailStore} from "../../../store";
import {dateFormat} from "../../../utils";
import {getStatus} from "./FmsUtil";

interface FmsPackageDetailTablePrps {
    items: ShipmentPackageItemDto[]
    notLocatableDialogStore: DialogStore
    cancelDocumentDialog: DialogStore
    reprintCoverLetter: (vin: string) => void
}

const FmsPackageDetailTable = observer(function ({
                                                     items,
                                                     notLocatableDialogStore,
                                                     reprintCoverLetter,
                                                     cancelDocumentDialog
                                                 }: FmsPackageDetailTablePrps) {
    return <>
        <ScrollTable>
            <thead>
            <tr>
                <th>Dokumentenart</th>
                <th style={{width: '14em'}}>FIN</th>
                <th>Dokumenten-Id</th>
                <th>Lagerort</th>
                <th>Last-Scan</th>
                <th>Pick-Status</th>
                <th style={{width: '3.5em'}}></th>
                <th style={{width: '3.5em'}}></th>
                <th style={{width: '3.5em'}}></th>
            </tr>
            </thead>
            <tbody>
            {items.map((val) => {
                return <tr key={val.id}
                           className={`${val.lost ? 'is-warning' : ''}`}>
                    <td>{convertDocumentType(val.documentType)}</td>
                    <td>
                        <div style={{display: 'flex'}}>
                            <span style={{paddingRight: '1em'}}>{val.vin}</span>
                            {fmsPackageDetailStore.data?.customerId && <Linq
                                to={`/vhs/${fmsPackageDetailStore.data?.customerId}/${val.vin}`}><span
                                className="material-symbols-outlined has-text-link">link</span></Linq>}
                        </div>
                    </td>
                    <td title={val.documentId}>{val.documentId}</td>
                    <td title={val.storageLocation}>{val.storageLocation}</td>
                    <td title={dateFormat(val.lastScan)}>{dateFormat(val.lastScan)}</td>
                    <td title={getStatus(val).text}>{getStatus(val).text}</td>
                    <td style={{width: '3.5em'}}>
                        {(val.picklistId
                                && !val.lastScan
                                && !val.lost
                                && !val.cancelled
                                && fmsPackageDetailStore.active)
                            &&
                            <button style={{padding: 0}} className={'button is-small is-ghost has-text-warning '}
                                    title="Dokument als nicht auffindbar markieren"
                                    onClick={() => {
                                        fmsPackageDetailStore.selectedItem = val
                                        notLocatableDialogStore.dialogOpen = true
                                    }}>
                                <span className="material-symbols-outlined">not_listed_location</span>
                            </button>}
                    </td>
                    <td style={{width: '3.5em'}}>
                        {(!val.ready
                                && !val.cancelled
                                && !val.picklistId
                                && fmsPackageDetailStore.active)
                            &&
                            <button style={{padding: 0}} className={'button is-small is-ghost has-text-warning '}
                                    title="Versand von Dokument stornieren"
                                    onClick={() => {
                                        fmsPackageDetailStore.selectedItem = val
                                        cancelDocumentDialog.dialogOpen = true
                                    }}>
                                <span className="material-symbols-outlined">cancel</span>
                            </button>}
                    </td>
                    <td className={'has-text-primary'} style={{width: '3.5em'}}>
                        {val.hasCoverLetter &&
                            <button title="Anschreiben drucken"
                                    className="material-symbols-outlined"
                                    disabled={!val.hasCoverLetter}
                                    onClick={() => {
                                        if (fmsDocumentPrinterStore.options.length === 0) {
                                            fmsDocumentPrinterStore.load().finally()
                                        }
                                        if (!fmsPackageDetailStore.printing) {
                                            reprintCoverLetter(val.vin)
                                        }
                                    }}
                            >print
                            </button>}
                    </td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
    </>
})

export {
    FmsPackageDetailTable
}
